import { render, staticRenderFns } from "./ContractDescription.vue?vue&type=template&id=3c08084d&scoped=true&lang=pug"
import script from "./ContractDescription.vue?vue&type=script&lang=js"
export * from "./ContractDescription.vue?vue&type=script&lang=js"
import style0 from "./ContractDescription.vue?vue&type=style&index=0&id=3c08084d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08084d",
  null
  
)

export default component.exports